import axios from '@/axios.js'
import router from '@/router.js';
import moment from 'moment'

export default {
    specialist({ state, commit, dispatch }, id) {
        state.specialist = null;
        // state.isLoading = true;
        // state.booking.servicesNumber = 1;
        // state.booking.currentStep = 1;
        // state.booking.availabilityDates = 1;
        // state.booking.selectedDayIndex = 1;
        // state.userServices = [];

        axios.get('/specialists/' + id)
            .then(function (response) {
                if(response.data.success === true){
                    commit('SPECIALIST', response);
                    state.isLoading = false;
                }
                else router.push('/specialists');
            });
    },

    buyService({ state, commit, dispatch }, data) {
        axios.post('/client/services/buy', data)
        .then(function (response) {
            dispatch('notification/notification', response, {root: true});
            if(response.status == 200 && response.data.success == true) {
                // UPDATE USER BALANCE
                dispatch('user/updateBalance', {
                amount: response.data.user.balance,
                    type: 'replace'
                }, {root: true })
                // UPDATE USER'S SERVICES AT ALL SPECIALISTS
                dispatch('user/updateServices', {
                    services: response.data.services,
                    type: 'push'
                }, {root: true })
                // UPDATE USER'S SERVICES AT SPECIALIST
                dispatch('specialist/updateUserServices', {
                    services: response.data.services,
                    type: 'push'
                }, {root: true })
                state.modals.buyService = false;
          } else if(response.status == 200) {
                var dataPayment = {
                    currency: response.data.currency,
                    gateway: response.data.gateway,
                    payment_ref: response.data.payment_ref,
                    client_secret: response.data.client_secret,
                    payment_type: response.data.payment_type,
                    to_pay: response.data.to_pay,
                    vat: response.data.vat,
                    total: response.data.total,
                    entity: 'service',
                    payload: data,
                    description: 'Alimentare cont'
                }
                dispatch('payments/updateUnfinished', dataPayment, {root: true});
                state.modals.buyService = false;
            }
        })
        .catch(function (error) {
            if(error.response.data.type != undefined && error.response.data.type == 'NO_BILLING_DETAILS'){
                dispatch('notification/notification', error.response, {root: true})
                dispatch('layout/billingDetailsModal', true, {root: true});
            }
        });
    },

    buyPackage({ state, commit, dispatch }, data) {
        axios.post('/client/packages/buy', data)
        .then(function (response) {
            dispatch('notification/notification', response, {root: true});

            if(response.status == 200 && response.data.success == false) {
                console.log('test');

                var dataPayment = {
                    currency: response.data.currency,
                    gateway: response.data.gateway,
                    payment_ref: response.data.payment_ref,
                    client_secret: response.data.client_secret,
                    payment_type: response.data.payment_type,
                    to_pay: response.data.to_pay,
                    vat: response.data.vat,
                    total: response.data.total,
                    entity: 'package',
                    payload: data,
                    description: 'Alimentare cont'
                }
                dispatch('payments/updateUnfinished', dataPayment, {root: true});
                state.modals.buyPackage = false;
            } else if(response.status == 200) {
                // UPDATE USER BALANCE
                dispatch('user/updateBalance', {
                    amount: response.data.user.balance,
                    type: 'replace'
                }, {root: true })
                // UPDATE USER'S SERVICES AT ALL SPECIALISTS
                dispatch('user/updateServices', {
                    services: response.data.services,
                    type: 'push'
                }, {root: true })
                // UPDATE USER'S SERVICES AT SPECIALIST
                dispatch('specialist/updateUserServices', {
                    services: response.data.services,
                    type: 'push'
                }, {root: true })
                state.modals.buyPackage = false;
            }
        })
        .catch(function (error) {
            console.log(error.response);
            if(error.response.data.type != undefined && error.response.data.type == 'NO_BILLING_DETAILS'){
                dispatch('notification/notification', error.response, {root: true})
                dispatch('layout/billingDetailsModal', true, {root: true});
            }
        });
    },

    // TYPE 1: push -> add services to userServices object
    // TYPE 2: remove -> remove services to userServices object
    // TYPE 3: replace -> replace userServices
    updateUserServices({ commit }, data) {
        commit('UPDATE_USER_SERVICES', data);
    },

    storeFeedback({ state, commit, dispatch }, data) {
        axios.post('/client/specialists/' + data.specialistId + '/reviews', data).then(function (response) {
            if(response.data.success){
                commit('STORE_FEEDBACK', response);
                dispatch('updateFeedbackGraph', { specialistId: state.specialist.id });
            }
            dispatch('notification/notification', response, { root: true })
        }).catch(function (error) {
            console.error(error);
        });
    },
    storeFeedbackEndMeeting({ state, commit, dispatch }, data) {
        axios.post('/client/specialists/' + data.specialistId + '/reviews', data).then(function (response) {
            if(response.data.success) commit('STORE_FEEDBACK', response);
            dispatch('notification/notification', response, { root: true })
        }).catch(function (error) {
            console.error(error);
        });
    },
    updateFeedbackGraph({ commit }, data) {
        axios.get('/client/specialist/' + data.specialistId + '/reviews').then(function (response) {
            commit('UPDATE_FEEDBACK_GRAPH', response);
        })
    },

    /* Booking */
    async fetchAvailability({ commit }, data) {
        commit('AVAILABILITY_DATES', null);

        const request = await axios.post(`/client/specialists/${ data.specialist_id }/availability-dates`, {
        date: moment().format('YYYY-MM-DD'),
        services_count: data.services_count,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        });

        console.log(request.data);

        commit('AVAILABILITY_DATES', request.data);
    },

    clearBooking({ commit }) {
        commit('CLEAR_BOOKING');
    },

    loadingBooking({ commit }, data) {
        commit('LOADING_BOOKING', data);
    },

    /* Transactions */
    changeTransactionsAppearance({ commit }, appearance) {
        commit('TRANSACTIONS_APPEARANCE', appearance);
    },

    async fetchTransactions({ commit, state }) {
        if (state.transactionsEnd) {
            return;
        }

        if (state.transactionsLoading) {
            return;
        }

        // Transactions per request
        const LOAD_NUMBER = 10;

        state.transactionsLoading = true;
        const request = await axios.get(
            `/specialist/transactions?limit=${ LOAD_NUMBER }&offset=${ state.transactions.length }`
        );

        if (request.data.success === false) {
            return;
        }

        if (request.data.transactionsCount !== LOAD_NUMBER) {
            state.transactionsEnd = true;
        }

        commit('TRANSACTIONS', request.data.transactions);
    },
    
    finishMeeting({ commit, dispatch }, id) {
        axios.get(`/specialist/meeting/${id}/finish`).then(function (response) {
            
            dispatch('notification/notification', response, {root: true});
            
            if(response.status == 200) {
                dispatch('meeting/finish', null,  {root: true})
                    .then(() => {
                        console.log('okkk');
                        dispatch('layout/widget', null,  {root: true});
                    });
            }
        })
    },
}
